import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

import { Button } from '../../../../../base/components/Button';
import { Header } from '../../../../../base/components/Header';

import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';

import { ReactComponent as ConfirmationImage } from '../../../../assets/img/vacancy-added-confirmation-icon.svg';
import { Helmet } from '../../../../components/Helmet';
import { RecommendedWorkers } from '../../components/Recommendations';
import { UpgradeModal } from '../../components/UpgradeModal';
import { vacancyActions } from '../../redux/slices/vacancySlice';

import './styles.scss';

export const VacancyConfirmation = () => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const { recommendations } = useAppSelector((state) => state.vacancy);
    const location = useLocation();

    useEffect(() => {
        if (id) {
            dispatch(vacancyActions.getRecommendationsRequest(id));
        }
    }, [id]);

    const [showUpgradeVacancyModal, setShowUpgradeVacancyModal] = useState(false);

    if (!recommendations) {
        return null;
    }

    return (
        <>
            <Helmet pageName={__t('Вакансия успешно опубликована!')} />
            <Header title={__t('Новая вакансия')} />
            <div className='vacancy-confirmation-page'>
                <div className='razem-app__wrapper'>
                    <div className='confirmation-block vacancy-confirmation-page__confirmation-block'>
                        <ConfirmationImage className='confirmation-block__icon' />
                        <h1 className='confirmation-block__title'>{__t('Вакансия успешно опубликована!')}</h1>
                        <p className='confirmation-block__text'>
                            {__t('Теперь вы сможете получать предложения, а также самостоятельно приглашать.')}
                        </p>
                        <Link to={'/vacancy/create'} className='confirmation-block__link' state={{ from: location }}>
                            {__t('Разместить еще одну вакансию')}
                        </Link>
                        <Button className='confirmation-block__button' onClick={() => setShowUpgradeVacancyModal(true)}>
                            {__t('Продвигать вакансию')}
                        </Button>
                        <p className='confirmation-block__upgrade-helper-text'>
                            &#128293;
                            {__t('х9 больше обращений')}
                        </p>
                    </div>

                    <RecommendedWorkers />
                </div>
            </div>
            {id && (
                <UpgradeModal
                    vacancyId={id}
                    visible={showUpgradeVacancyModal}
                    closeModalHandler={() => setShowUpgradeVacancyModal(false)}
                />
            )}
        </>
    );
};
